const certifications = [
  {
    name: "Cyber Essentials",
    status: "CERTIFIED",
    statusColor: "var(--color-emerald, #10b981)",
    description: "UK government-backed cyber security certification.",
    logo: "/cert-cyber-essentials.png",
  },
  {
    name: "GDPR",
    status: "ALIGNED",
    statusColor: "var(--color-accent)",
    description:
      "Data processing agreements and lawful basis documentation built in.",
    logo: "/cert-gdpr.png",
  },
  {
    name: "ISO 27001",
    status: "ALIGNED",
    statusColor: "var(--color-accent)",
    description:
      "Information security management controls across infrastructure.",
    logo: "/cert-iso27001.png",
  },
  {
    name: "SOC 2 Type II",
    status: "ALIGNED",
    statusColor: "var(--color-accent)",
    description:
      "Trust service criteria for security, availability, and confidentiality.",
    logo: "/cert-soc2.png",
  },
];

const practices = [
  {
    title: "AES-256 Encryption",
    description: "Data encrypted at rest and in transit.",
  },
  {
    title: "UK/EU Data Residency",
    description: "No offshore processing.",
  },
  {
    title: "Full Audit Trails",
    description: "Every AI action logged and traceable.",
  },
];

export function IntroSecuritySlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="flex flex-col h-full">
      <h2 className="text-[32px] font-light tracking-tight font-[family-name:var(--font-heading)] mb-4">
        Built for firms where compliance is non-negotiable.
      </h2>

      {/* Section 1: Certifications */}
      <div
        className="grid grid-cols-2 gap-2.5 mb-4"
        style={{ gridAutoRows: "1fr" }}
      >
        {certifications.map((cert) => (
          <div
            key={cert.name}
            className="relative overflow-hidden border border-[var(--color-border)] px-4 py-2.5 rounded-sm"
          >
            <img
              src={cert.logo}
              alt=""
              className="absolute -right-2 top-1/2 -translate-y-1/2 h-[110%] w-auto object-contain pointer-events-none"
              style={{ opacity: 0.06 }}
            />
            <div className="relative z-10">
              <p className="text-[14px] font-medium text-[var(--color-fg)]">
                {cert.name}
              </p>
              <p
                className="text-[10px] font-mono uppercase tracking-widest mt-0.5"
                style={{ color: cert.statusColor }}
              >
                {cert.status}
              </p>
              <p className="text-[10px] text-[var(--color-fg-secondary)] leading-relaxed mt-1">
                {cert.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Section 2: Key Practices */}
      <div className="grid grid-cols-3 gap-2.5">
        {practices.map((practice) => (
          <div
            key={practice.title}
            className="border border-[var(--color-border)] px-4 py-2.5 rounded-sm"
          >
            <p className="text-[14px] font-medium text-[var(--color-fg)]">
              {practice.title}
            </p>
            <p className="text-[10px] text-[var(--color-fg-secondary)] leading-relaxed mt-1">
              {practice.description}
            </p>
          </div>
        ))}
      </div>

      {/* Bottom bar */}
      <div className="text-left mt-auto mb-8 pb-4 border-b border-[var(--color-border)]">
        <p className="text-[12px] text-[var(--color-fg-secondary)] font-light">
          Full technical security documentation available on request.
        </p>
      </div>
    </div>
  );
}
